<app-modal-wrapper [(isValid)]="isValid" (save)="onSave($event)" (cancel)="onCancel($event)" [options]="options">
  <div class="search-save-poup-container card-body">
    <div class="form-group col-12">
      <label class="form-label">{{msg}}</label>
    </div>
  </div>
</app-modal-wrapper>
